<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container lg">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">背景画像の変更</span>
        </div>
        <div class="popup-content">
          <p class="txt">ご希望の背景画像を選択してください。</p>
          <div class="popup-content-inner">
            <div class="column gutter">

              <div v-for="(item, index) in group1.backgroundList" :key="'bg_' + index" class="column-item col-4 space-gutter">
                <div role="button" class="bgimage-sample" 
                  :class="{'current' : item.template === group1.template}"
                  @click="group1.onImageClicked(item.template)"
                >
                  <img :src="item.image" alt="">
                </div>
              </div>

            </div>
          </div>
          <div class="button mt32">
            <button class="btn" type="submit" @click="group1.onSubmitButtonClicked">設定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import * as logicProfileChangeBackground from '@/logic/profile/ProfileChangeBackground'

export default defineComponent({

  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicProfileChangeBackground.getGroup(props, context)

    const close = () => {
      context.emit('closeProfileChangeBackground')
    }
   
    return {
      group1,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-content-inner {
  background-color: #F9F8F6;
  border-radius: 8px;
  border: 1px solid $color-line;
  padding: 40px;
}
.bgimage-sample {
  @include hoverOpacity();
  &.current {
    img {
      border: 4px solid $color-link;
      opacity: 1;
    }
  }
  img {
    display: block;
    width: 100%;
    border-radius: 8px;
    opacity: .2;
  }
}
.popup-content {
  .button .btn {
    width: 230px;
    margin: 0 auto;
  }
}
</style>
